export const events = {
  UPDATING_DATA: 'priceEstimatorService:updatingData',
  DATA_UPDATED: 'priceEstimatorService:dataUpdated',
  UPDATING_ESTIMATED_PRICE: 'priceEstimatorService.updatingEstimatedPrice',
  ESTIMATED_PRICE_UPDATED: 'priceEstimatorService.estimatedPriceUpdated',
  STOP_WATCHING: 'priceEstimatorService.stopWatching',
};

export default events;
